import React, { useRef, useEffect } from "react";
import { gsap, Power1 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import logo from "../logo/logo2.jpg";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  let scrollText = useRef(null);
  let reff = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    document.title = "Akshit Rana - Web Developer | Illustrator ";
    const element = reff.current;
    const hero = element.querySelector(".hero");
    const blob = element.querySelector(".blob");
    const img = element.querySelector("img");
    const water = element.querySelector(".waterMark");
    const title = element.querySelector(".heading");
    const para = element.querySelector(".para");
    const bio = element.querySelector(".bio>.name");
    const links = element.querySelector(".links");
    const social = element.querySelector(".social_links");
    const first_scroll = scrollText.firstChild;
    const second_scroll = scrollText.lastChild;
    let tl = gsap.timeline({ defaults: { duration: 1 } });
    tl.fromTo(
      hero,
      0.6,
      { y: -44, opacity: 0 },
      { y: 0, opacity: 1, ease: Power1.easeOut },
      1.6
    )
      .fromTo(
        blob,
        0.6,
        { opacity: 0 },
        { opacity: 1, ease: Power1.easeOut },
        1.8
      )
      .fromTo(
        img,
        0.6,
        { height: 0 },
        { height: "auto", ease: Power1.easeOut },
        1.8
      )
      .fromTo(
        water,
        0.6,
        { x: 174, opacity: 0.6 },
        { x: 0, opacity: 0.1, ease: Power1.easeOut },
        2
      )
      .fromTo(
        title,
        0.6,
        { y: 200 },
        { y: 0, ease: [0.6, 0.01, -0.05, 0.95] },
        2.2
      )
      .fromTo(
        para,
        0.6,
        { y: 200 },
        { y: 0, ease: [0.6, 0.01, -0.05, 0.95] },
        2.4
      )
      .fromTo(
        social,
        0.6,
        { y: 200 },
        { y: 0, ease: [0.6, 0.01, -0.05, 0.95] },
        2.6
      )
      .fromTo(
        bio,
        0.6,
        { y: 44, opacity: 0 },
        { y: 0, opacity: 1, ease: Power1.easeOut },
        2.6
      )
      .fromTo(
        links,
        0.6,
        { y: 44, opacity: 0 },
        { y: 0, opacity: 1, ease: Power1.easeOut },
        2.8
      );
    gsap.fromTo(
      first_scroll,
      1,
      { x: 0 },
      {
        x: 500,
        ease: Power1.easeIn,
        scrollTrigger: {
          trigger: scrollText,
          start: "top center+=100",
          scrub: true,
        },
      }
    );
    gsap.fromTo(
      second_scroll,
      1,
      { x: 50 },
      {
        x: -550,
        ease: Power1.easeIn,
        scrollTrigger: {
          trigger: scrollText,
          start: "top center+=100",
          scrub: true,
        },
      }
    );
  }, []);

  useEffect(() => {
    const menu = document.querySelectorAll(".nav-link");
    if (inView) {
      menu[0].classList.add("active");
      menu[1].classList.remove("active");
      menu[2].classList.remove("active");
      menu[3].classList.remove("active");
      menu[4].classList.remove("active");
    }
  }, [inView]);

  return (
    <>
      <motion.main
        ref={ref}
        initial={{ visibility: "hidden" }}
        animate={{ visibility: "visible", transition: { delay: 1 } }}
        exit={{ visibility: "hidden", transition: { delay: 1 } }}
        id="content"
      >
        <div className="section" id="home">
          <div className="home" ref={reff}>
            <div className="hero">
              <span className="blob">
                <img src={logo} alt="Akshit" />
              </span>
              <div style={{ overflow: "hidden" }}>
                <div className="waterMark">
                  <div>D &nbsp;E</div>
                  <div>S &nbsp;&nbsp;I</div>
                  <div>G &nbsp;N</div>
                  <div>E &nbsp;R</div>
                </div>
              </div>
            </div>
            <div className="title">
              <div style={{ overflow: "hidden" }}>
                <h2 className="heading">
                  Full Stack Web Developer And illustrator
                </h2>
              </div>
              <div style={{ overflow: "hidden" }}>
                <p className="para">
                  I am passionate and creative web Developer ,illustrator and
                  Ui/Ux Designer with experience in making beautiful interfaces
                  for web and mobile.
                </p>
                <div className="social_links">
                  <a
                    className="fb_link "
                    href="https://www.facebook.com/akshit.rana3"
                    target={"_open"}
                  >
                    <i className="fab fa-facebook" title="Facebook"></i>
                  </a>
                  <a
                    className="linkedin_link "
                    href="https://www.linkedin.com/in/akshit-rana-10"
                    target={"_open"}
                  >
                    {" "}
                    <i className="fab fa-linkedin" title="Linked in"></i>
                  </a>
                  <a
                    className="github_link "
                    href="https://github.com/Akshit3010"
                    target={"_open"}
                  >
                    <i className="fab fa-github" title="GitHub"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="bio">
              <div className="name">
                <h1>Akshit</h1>
                <span>Rana</span>
              </div>
              <div className="links">
                {" "}
                <a href="#About">Read about me</a> OR{" "}
                <a href="#projects">View projects</a>
              </div>
            </div>
          </div>
        </div>
      </motion.main>

      <section id="Art">
        <div className="container">
          <div
            className="scroll_text"
            ref={(elem) => {
              scrollText = elem;
            }}
          >
            <motion.p transition={{ ease: "easeOut" }}>
              Turning Ideas into
            </motion.p>
            <p>
              <span> Digital Experiences</span>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
